import { GradientBorder } from "@storytell/chat-ui/ui";
import { type JSX, Show } from "solid-js";

const HERO_ACCENT_GRADIENT =
  "radial-gradient(at 30% 10%, color-mix(in srgb, var(--color-glow) 70%, white) 0%, color-mix(in srgb, var(--color-glow) 40%, transparent) 12%, color-mix(in srgb, var(--color-brand) 50%, transparent) 50%, color-mix(in srgb, var(--color-brand) 40%, transparent) 100%)";

/**
 * Pull-quote wrapped in the same accent-gradient border used on the landing page hero.
 * The inner surface uses the normal panel background so it reads cleanly against body copy.
 *
 *   import { GradientQuote } from "~/components/marketing/GradientQuote";
 *
 *   <GradientQuote>Your emphatic quote here.</GradientQuote>
 */
export function GradientQuote(props: { children: JSX.Element; cite?: string }) {
  return (
    <figure class="my-10">
      <GradientBorder
        rounded="rounded-2xl"
        bgColor="bg-panel"
        accentGradient={HERO_ACCENT_GRADIENT}
        showAccent
        glowOnAccent
      >
        <blockquote class="relative z-10 rounded-2xl bg-panel p-10 text-center text-xl/snug font-semibold tracking-tight text-primary-text sm:p-14 sm:text-2xl lg:text-3xl [&>*:last-child]:mb-0!">
          {props.children}
        </blockquote>
      </GradientBorder>
      <Show when={props.cite}>
        <figcaption class="mt-4 text-center text-sm text-secondary-text">— {props.cite}</figcaption>
      </Show>
    </figure>
  );
}
